import { useState, useEffect } from 'preact/hooks';

const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(false);

  useEffect(() => {
    if (!value) {
      setDebouncedValue(false);
      return;
    }
    const t = setTimeout(() => setDebouncedValue(true), delay);
    return () => clearTimeout(t);
  }, [value, delay]);

  return debouncedValue;
};

export default useDebounce;
